const prefixingUrl = (url) => {
  if (!url.startsWith('http')) {
    return `https://${url}`;
  }

  return url;
};

export default prefixingUrl;
